"use client";
import { DollarSign, Search } from "lucide-react";
import { type ReactNode, useState } from "react";

import { getIconClass } from "@/components/assets/icon/icons";

type SearchBarProps = {
  leftPlaceholder?: string;
  middlePlaceholder?: string;
  rightPlaceholder?: string;
  leftIcon?: ReactNode;
  middleIcon?: ReactNode;
  rightIcon?: ReactNode;
};

export default function SearchBar({
  leftPlaceholder = "Search...",
  middlePlaceholder = "By Trade",
  rightPlaceholder = "By Budget",
  leftIcon = <Search className="h-5 w-5 shrink-0 text-gray-400" />,
  middleIcon = (
    <span className={`${getIconClass("tradie", "md")} text-gray-400`} />
  ),
  rightIcon = <DollarSign className="h-5 w-5 shrink-0 text-gray-400" />,
}: SearchBarProps) {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <div className="relative mx-auto mb-10 max-w-4xl">
      <div className="flex flex-col gap-2 rounded-lg border-4 border-custom-yellow-dark bg-white p-2 shadow-lg sm:flex-row sm:gap-0">
        {/* Search Input */}
        <div className="flex flex-1 items-center gap-2 rounded-md border border-gray-200 px-4 py-3 focus-within:border-custom-blue focus-within:ring-2 focus-within:ring-custom-blue/20 sm:rounded-r-none sm:border-r-0">
          {leftIcon}
          <input
            className="w-full border-none bg-transparent text-gray-900 placeholder:text-gray-400 focus:outline-none"
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder={leftPlaceholder}
            type="text"
            value={searchQuery}
          />
        </div>

        {/* Trade Input */}
        <div className="flex flex-1 items-center gap-2 rounded-md border border-gray-200 px-4 py-3 focus-within:border-custom-blue focus-within:ring-2 focus-within:ring-custom-blue/20 sm:rounded-none sm:border-r-0">
          {middleIcon}
          <input
            className="w-full border-none bg-transparent text-gray-900 placeholder:text-gray-400 focus:outline-none"
            placeholder={middlePlaceholder}
            type="text"
          />
        </div>

        {/* Budget Input */}
        <div className="flex flex-1 items-center gap-2 rounded-md border border-gray-200 px-4 py-3 focus-within:border-custom-blue focus-within:ring-2 focus-within:ring-custom-blue/20 sm:rounded-none sm:border-r-0">
          {rightIcon}
          <input
            className="w-full border-none bg-transparent text-gray-900 placeholder:text-gray-400 focus:outline-none"
            placeholder={rightPlaceholder}
            type="text"
          />
        </div>

        {/* Search Button */}
        <button
          className="rounded-md bg-custom-yellow px-6 py-3 font-semibold text-custom-blue-dark transition-colors hover:bg-custom-yellow/90 focus:outline-none focus:ring-2 focus:ring-custom-yellow focus:ring-offset-2 sm:rounded-l-none"
          type="button"
        >
          Search
        </button>
      </div>{" "}
    </div>
  );
}
